import { BrowserModule } from '@angular/platform-browser';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { HeaderComponent } from './Shared/header/header.component';
import { FooterComponent } from './Shared/footer/footer.component';
import { HomeComponent } from './Components/home/home.component';
import { FeaturesComponent } from './Components/features/features.component';
import { ExamplesComponent } from './Components/examples/examples.component';
import { PricingComponent } from './Components/pricing/pricing.component';
import { EnterpriseComponent } from './Components/enterprise/enterprise.component';
import { wordpluginComponent } from './Components/word-plugin/word-plugin.component';
import { TrinkaCloudComponent } from './Components/trinka-cloud/trinka-cloud.component';
import { AboutUsComponent } from './Components/about-us/about-us.component';
import { ContactUsComponent } from './Components/contact-us/contact-us.component';
import { WorkWithUsComponent } from './Components/work-with-us/work-with-us.component';
import { PrivacyPolicyComponent } from './Components/privacy-policy/privacy-policy.component';
import { TermServicesComponent } from './Components/term-services/term-services.component';
import { PageNotFoundComponent } from './Components/page-not-found/page-not-found.component';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './models/material-components.service';
import { HttpClientModule } from '@angular/common/http';
import { CKEditorModule } from 'ngx-ckeditor';
import { ToastrModule } from 'ngx-toastr';
import { MaterialModuleList } from './material-module';
import { NgtUniversalModule } from '@ng-toolkit/universal';
import { AppComponent } from './app.component';
import { TransferHttpCacheModule } from '@nguniversal/common';
import { GcEditorComponent } from './Components/gc-editor/gc-editor.component';
import { FAQComponent } from './Components/faq/faq.component';
import { TrinkaVsLanguagetoolComponent } from './Components/trinka-vs-languagetool/trinka-vs-languagetool.component';
import { TrinkaVsGingerComponent } from './Components/trinka-vs-ginger/trinka-vs-ginger.component';
import { TrinkaVsWritefullComponent } from './Components/trinka-vs-writefull/trinka-vs-writefull.component';
import { LifeSciencesMedicineAndPharmaComponent } from './Components/enterprise/life-sciences-medicine-and-pharma/life-sciences-medicine-and-pharma.component';
import { LanguageServicesPublishingAndMediaComponent } from './Components/enterprise/language-services-publishing-and-media/language-services-publishing-and-media.component';
import { AcademicInstitutionsComponent } from './Components/enterprise/academic-institutions/academic-institutions.component';
import { K12AndElearningComponent } from './Components/enterprise/k12-and-elearning/k12-and-elearning.component';
import { TechnologyPlatformsComponent } from './Components/enterprise/technology-platforms/technology-platforms.component';
import { ConsistencyChecksComponent } from './Components/features/consistency-checks/consistency-checks.component';
import { PersonalDictionaryComponent } from './Components/features/personal-dictionary/personal-dictionary.component';
import { CreditsComponent } from './Components/features/credits/credits.component';
import { PublicationChecksComponent } from './Components/publication-checks/publication-checks.component';
import { AutoEditComponent } from './Components/auto-edit/auto-edit.component';
import { PlagiarismCheckerComponent } from './Components/features/plagiarism-checker/plagiarism-checker.component';
import { PunctuationCheckerComponent } from './Components/punctuation-checker/punctuation-checker.component';
import { SpellCheckerComponent } from './Components/spell-checker/spell-checker.component';
import { SentenceCheckerComponent } from './Components/sentence-checker/sentence-checker.component';
import { APIComponent } from './Components/enterprise/api/api.component';
import { CitationCheckerComponent } from './Components/features/citation-checker/citation-checker.component';
import { CitationSampleReportComponent } from './Components/features/citation-checker/citation-sample-report/citation-sample-report.component';
import { EnglishGrammarCheckerComponent } from './Components/english-grammar-checker/english-grammar-checker.component';
import { FeedbackModalComponent } from './Components/feedback-modal/feedback-modal.component';
import { DetectionLimitExhaustModalComponent } from './Components/detection-limit-exhaust-modal/detection-limit-exhaust-modal.component';
import { MultilingualEditorMarketingModule } from '@crimson-mohit/multilingual-editor-marketing';
import { SpanishGrammarCheckerComponent } from './Components/spanish-grammar-checker/spanish-grammar-checker.component';
import { DocumarkComponent } from './Components/features/documark/documark.component';
import { EnterpriseModalComponent } from './Components/enterprise/enterprise-modal/enterprise-modal.component';
import { SharedModule } from './modules/shared.module';
import { GrammarCheckerFeaturesComponent } from './Components/features/grammar-checker-features/grammar-checker-features.component';
import { LatexGrammarCheckerComponent } from './Components/features/latex-grammar-checker/latex-grammar-checker.component';
import { InclusiveLanguageReportComponent } from './Components/features/inclusive-language-report/inclusive-language-report.component';
import { OnlineParaphraserComponent } from './Components/features/online-paraphraser/online-paraphraser.component';
import { LegalWritingComponent } from './Components/features/legal-writing/legal-writing.component';
import { AIAppsLibraryComponent } from './Components/features/ai-studio/aiapps-library/aiapps-library.component';
import { AskTrinkaComponent } from './Components/features/ai-studio/ask-trinka/ask-trinka.component';
import { DataSensitivePlanComponent } from './Components/enterprise/data-sensitive-plan/data-sensitive-plan.component';
import { AIContentDetectorFeaturesComponent } from './Components/features/aicontent-detector-features/aicontent-detector-features.component';
import { CitationFormatterComponent } from './Components/features/citation-formatter/citation-formatter.component';
import { JournalFinderComponent } from './Components/features/journal-finder/journal-finder.component';
import { BrowserPluginComponent } from './Components/browser-plugin/browser-plugin.component';
import { WindowsDesktopAppComponent } from './Components/windows-desktop-app/windows-desktop-app.component';
import { WordPluginLiteComponent } from './Components/word-plugin-lite/word-plugin-lite.component';
import { EnterpriseSharedModule } from './modules/enterprise-shared.module';
import { OnPremiseGrammarCheckerComponent } from './Components/enterprise/on-premise-grammar-checker/on-premise-grammar-checker.component';
import { CustomAIModelsComponent } from './Components/enterprise/custom-aimodels/custom-aimodels.component';
import { HowWeDoItComponent } from './Components/enterprise/custom-aimodels/how-we-do-it/how-we-do-it.component';
import { ProcessModelComponent } from './Components/enterprise/custom-aimodels/process-model/process-model.component';
import { WhyChooseUsComponent } from './Components/enterprise/custom-aimodels/why-choose-us/why-choose-us.component';
import { RLHFComponent } from './Components/enterprise/custom-aimodels/rlhf/rlhf.component';
import { ParapharsingToolComponent } from './Components/parapharsing-tool/parapharsing-tool.component';
import { AiDetectorToolComponent } from './Components/ai-detector-tool/ai-detector-tool.component';
import { AiContentFeedbackModalComponent } from './Components/ai-content-feedback-modal/ai-content-feedback-modal.component';
import { JournalFinderToolComponent } from './Components/journal-finder-tool/journal-finder-tool.component';
import { JournalFinderToolsPageComponent } from './Components/journal-finder-tools-page/journal-finder-tools-page.component';
import { OpenAccessFilterPipe } from './_pipes/open-access.pipe';
import { TargetJournalFilterPipe } from './_pipes/target-journal.pipe';
import { PredatoryFilterPipe } from './_pipes/predatory.pipe';
import { CiteScorePipe } from './_pipes/cite-score.pipe';
import { HIndexPipe } from './_pipes/h-index.pipe';
import { ImpactFactorPipe } from './_pipes/impact-factor.pipe';
import { ChartComponent } from './Components/journal-finder-tool/chart/chart.component';
import { ChartsModule } from 'ng2-charts';
import { AcademicPhrasebankComponent } from './Components/academic-phrasebank/academic-phrasebank.component';
import { AcademicPhrasebankBrowseComponent } from './Components/academic-phrasebank-browse/academic-phrasebank-browse.component';
import { SubscribeFormComponent } from './Components/subscribe-form/subscribe-form.component';
import { PaginationComponent } from './Components/pagination/pagination.component';
import { HighlightKeywordsDirective } from './_directives/highlightKeywords.directive';
import { EnterpriseFormPageComponent } from './Components/enterprise-form-page/enterprise-form-page.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    FeaturesComponent,
    ExamplesComponent,
    PricingComponent,
    EnterpriseComponent,
    wordpluginComponent,
    TrinkaCloudComponent,
    TrinkaVsGingerComponent,
    TrinkaVsLanguagetoolComponent,
    TrinkaVsWritefullComponent,
    AboutUsComponent,
    ContactUsComponent,
    WorkWithUsComponent,
    PrivacyPolicyComponent,
    TermServicesComponent,
    PageNotFoundComponent,
    GcEditorComponent,
    FAQComponent,
    LifeSciencesMedicineAndPharmaComponent,
    LanguageServicesPublishingAndMediaComponent,
    AcademicInstitutionsComponent,
    K12AndElearningComponent,
    TechnologyPlatformsComponent,
    ConsistencyChecksComponent,
    PersonalDictionaryComponent,
    CreditsComponent,
    PublicationChecksComponent,
    AutoEditComponent,
    PlagiarismCheckerComponent,
    PunctuationCheckerComponent,
    SpellCheckerComponent,
    SentenceCheckerComponent,
    APIComponent,
    CitationCheckerComponent,
    CitationSampleReportComponent,
    EnglishGrammarCheckerComponent,
    FeedbackModalComponent,
    DetectionLimitExhaustModalComponent,
    SpanishGrammarCheckerComponent,
    DocumarkComponent,
    EnterpriseModalComponent,
    GrammarCheckerFeaturesComponent,
    LatexGrammarCheckerComponent,
    InclusiveLanguageReportComponent,
    OnlineParaphraserComponent,
    LegalWritingComponent,
    AIAppsLibraryComponent,
    AskTrinkaComponent,
    DataSensitivePlanComponent,
    AIContentDetectorFeaturesComponent,
    CitationFormatterComponent,
    JournalFinderComponent,
    BrowserPluginComponent,
    WindowsDesktopAppComponent,
    WordPluginLiteComponent,
    OnPremiseGrammarCheckerComponent,
    CustomAIModelsComponent,
    HowWeDoItComponent,
    ProcessModelComponent,
    WhyChooseUsComponent,
    RLHFComponent,
    ParapharsingToolComponent,
    AiDetectorToolComponent,
    AiContentFeedbackModalComponent,
    JournalFinderToolComponent,
    JournalFinderToolsPageComponent,
    OpenAccessFilterPipe,
    TargetJournalFilterPipe,
    PredatoryFilterPipe,
    CiteScorePipe,
    HIndexPipe,
    ImpactFactorPipe,
    ChartComponent,
    AcademicPhrasebankComponent,
    AcademicPhrasebankBrowseComponent,
    SubscribeFormComponent,
    PaginationComponent,
    HighlightKeywordsDirective,
    EnterpriseFormPageComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    CKEditorModule,
    MaterialModule,
    MaterialModuleList,
    AppRoutingModule,
    HttpClientModule,
    NgtUniversalModule,
    ToastrModule.forRoot(),
    TransferHttpCacheModule,
    CommonModule,
    SharedModule,
    ChartsModule,
    EnterpriseSharedModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    MultilingualEditorMarketingModule
  ],
  providers: [],
  bootstrap: [AppComponent],
  schemas: [NO_ERRORS_SCHEMA]
})
export class AppModule { }
